import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { t } from "i18next";
import "./CurrentProjects.css";
import { baseUrl } from "../../config";

const getPageSize = () => {
  if (typeof window === "undefined") return 3;
  return window.innerWidth <= 768 ? 1 : 3;
};

const SliderCurrentProject = ({ currentProj = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [pageSize, setPageSize] = useState(getPageSize);

  useEffect(() => {
    const handleResize = () => {
      setPageSize(getPageSize());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setCurrentIndex((current) => {
      if (currentProj.length === 0) return 0;
      return Math.min(current, Math.max(0, currentProj.length - 1));
    });
  }, [currentProj.length, pageSize]);

  const visibleProjects = useMemo(() => {
    if (!currentProj.length) return [];

    const result = [];

    for (let offset = 0; offset < Math.min(pageSize, currentProj.length); offset += 1) {
      result.push(currentProj[(currentIndex + offset) % currentProj.length]);
    }

    return result;
  }, [currentProj, currentIndex, pageSize]);

  const nextSlide = () => {
    if (!currentProj.length) return;

    setCurrentIndex(
      (current) => (current + pageSize) % currentProj.length
    );
  };

  const prevSlide = () => {
    if (!currentProj.length) return;

    setCurrentIndex(
      (current) =>
        (current - pageSize + currentProj.length) % currentProj.length
    );
  };

  return (
    <div className="skyua-project-slider">
      <button
        type="button"
        className="skyua-project-slider__arrow skyua-project-slider__arrow--prev"
        onClick={prevSlide}
        aria-label="Previous projects"
      >
        <img
          src={baseUrl + "/sliderPrev.png"}
          alt=""
          aria-hidden="true"
        />
      </button>

      <div className="skyua-project-slider__viewport">
        <div className="skyua-project-slider__grid">
          {visibleProjects.map((item, index) => (
            <article
              key={`${item.id}-${currentIndex}-${index}`}
              className="skyua-project-card"
            >
              <div className="skyua-project-card__image">
                <img
                  src={
                    process.env.REACT_APP_BACKEND_LINK +
                    `/${item.photo_title}`
                  }
                  alt={t(item.name)}
                />

                <span className="skyua-project-card__label">
                  {t("actual projects title")}
                </span>
              </div>

              <div className="skyua-project-card__body">
                <h3>{t(item.name)}</h3>

                <p>
                  <strong>{t("The purpose of the project")} </strong>
                  {t(item.meta)}
                </p>

                <Link
                  className="skyua-project-card__link"
                  to={`/project/${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("btn projects")}
                  <span aria-hidden="true">→</span>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>

      <button
        type="button"
        className="skyua-project-slider__arrow skyua-project-slider__arrow--next"
        onClick={nextSlide}
        aria-label="Next projects"
      >
        <img
          src={baseUrl + "/slideNext.png"}
          alt=""
          aria-hidden="true"
        />
      </button>
    </div>
  );
};

export default SliderCurrentProject;
